import React from 'react';

function formatCents(cents) {
  return ((cents || 0) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export default function InvoiceAmountCell({ amountCents }) {
  return <span>{formatCents(amountCents)}</span>;
}
